import { render } from "./PackageShow.vue?vue&type=template&id=653595fc&scoped=true"
import script from "./PackageShow.vue?vue&type=script&lang=js"
export * from "./PackageShow.vue?vue&type=script&lang=js"

import "./PackageShow.vue?vue&type=style&index=0&id=653595fc&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653595fc"]])

export default __exports__